import { Box, Chip, useTheme } from '@mui/material';

import { Kiosk_Ad_Set_Status } from '@occc/graphql';

type AdSetStatusChipProps = {
  status: Kiosk_Ad_Set_Status;
};

const getStatusConfig = (status: Kiosk_Ad_Set_Status) => {
  switch (status) {
    case Kiosk_Ad_Set_Status.Published:
      return { label: 'Published', color: '#4caf50' };
    case Kiosk_Ad_Set_Status.Draft:
      return { label: 'Draft', color: '#ff9800' };
    case Kiosk_Ad_Set_Status.Archived:
      return { label: 'Archived', color: '#9e9e9e' };
    default:
      return { label: status, color: '#9e9e9e' };
  }
};

export const AdSetStatusChip = ({ status }: AdSetStatusChipProps) => {
  const theme = useTheme();
  const { label, color } = getStatusConfig(status);

  return (
    <Chip
      size='small'
      label={
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Box
            sx={{
              width: 12,
              height: 12,
              borderRadius: '50%',
              backgroundColor: color,
            }}
          />
          {label}
        </Box>
      }
      sx={{
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        color: theme.palette.text.primary,
        fontWeight: 400,
        '& .MuiChip-label': {
          px: 1,
        },
      }}
    />
  );
};
